import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AzureSynapseArtifactsLinkedService, azureSynapseArtifactsAuthTypes, A365BackendModel, Credential } from 'shell-models-lib';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ReferenceAdapter } from '../reference.adapter';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSynapseArtifactsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                authentication: '*',
                workspaceResourceId: '*',
                credential: GlobalVariables.enableSynapseLinkedServiceUami ? '*' : undefined,
            },
            parameters: '*'
        }
    }
})
export class AzureSynapseLinkedServiceAdapter extends LinkedServiceAdapter<AzureSynapseArtifactsLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => AzureSynapseArtifactsLinkedService {
        return AzureSynapseArtifactsLinkedService;
    }

    protected model(): IModel {
        return AzureSynapseArtifactsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureSynapseArtifactsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as A365BackendModel.AzureSynapseArtifactsLinkedService;

        properties.type = Metamodel.modelFor(AzureSynapseArtifactsLinkedService).name;

        properties.typeProperties = {
            endpoint: this.valueToResource(linkedService, AzureSynapseArtifactsLinkedService.ENDPOINT),
            authentication: 'MSI',
            workspaceResourceId: this.valueToResource(linkedService, AzureSynapseArtifactsLinkedService.WORKSPACE_RESOURCE_ID),
        };

        if (GlobalVariables.enableSynapseLinkedServiceUami && linkedService.authenticationMethod === azureSynapseArtifactsAuthTypes.UserAssignedManagedIdentity && linkedService.credential) {
            properties.typeProperties.credential = ReferenceAdapter.toResource(linkedService.credential, this.context) as Model.CredentialReference;
        }

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureSynapseArtifactsLinkedService): Promise<AzureSynapseArtifactsLinkedService> {
        const properties = linkedServiceResource.properties as A365BackendModel.AzureSynapseArtifactsLinkedService;

        ValueAdapter.toModel(linkedService, AzureSynapseArtifactsLinkedService.ENDPOINT, properties.typeProperties.endpoint);
        ValueAdapter.toModel(linkedService, AzureSynapseArtifactsLinkedService.WORKSPACE_RESOURCE_ID, properties.typeProperties.workspaceResourceId);

        if (GlobalVariables.enableSynapseLinkedServiceUami && properties.typeProperties.credential) {
            linkedService.credential = ReferenceAdapter.toProxyModel(Metamodel.modelFor(Credential), properties.typeProperties.credential, this.context);
            linkedService.authenticationMethod = azureSynapseArtifactsAuthTypes.UserAssignedManagedIdentity;
        } else {
            linkedService.authenticationMethod = azureSynapseArtifactsAuthTypes.MSIAuthentication;
        }

        return linkedService;
    }
}
